module.exports = __webpack_public_path__ + "static/media/img_process4.a7e31f94.png";